// Strikt: Produktionswoche 01–53, exakt 28 Zeichen
const STRICT = /^21\d{2}(0[1-9]|[1-4]\d|5[0-3])\d{10}\d{3}\d{6}\d{2}N\d$/;

// Vereinfacht: nur Grundstruktur prüfen (z. B. bei leicht abweichenden Schreibweisen)
const SIMPLIFIED = /^21\d{24}N\d$/;

export type VaillantValidationResult =
  | { valid: true }
  | { valid: false; reason: string };

export interface VaillantSerialNumberFormState {
  trimmed: string;
  formatValid: boolean;
  canSubmit: boolean;
}

/**
 * Geteilte Ableitung von trimmed/formatValid/canSubmit für alle Seriennummer-Formulare
 * (SeriennummerModal, SeriennummerRegistrierenModal), damit sich die Submit-Bedingung
 * nicht in jedem Modal unabhängig entwickelt.
 */
export function getVaillantSerialNumberFormState(
  rawValue: string,
  options: { isChecking?: boolean } = {}
): VaillantSerialNumberFormState {
  const trimmed = rawValue.trim();
  const formatValid = trimmed.length === 0 || validateVaillantSerialNumber(trimmed).valid;
  const canSubmit = trimmed.length > 0 && formatValid && !options.isChecking;
  return { trimmed, formatValid, canSubmit };
}

export function validateVaillantSerialNumber(value: string): VaillantValidationResult {
  const s = value.trim();

  if (s.length === 0) {
    return { valid: false, reason: 'Seriennummer ist leer.' };
  }

  if (STRICT.test(s)) {
    return { valid: true };
  }

  if (SIMPLIFIED.test(s)) {
    return { valid: true };
  }

  if (s.length !== 28) {
    return {
      valid: false,
      reason: `Erwartet 28 Zeichen, eingegeben: ${s.length}.`,
    };
  }

  if (!s.startsWith('21')) {
    return { valid: false, reason: 'Muss mit „21" beginnen.' };
  }

  if (s[25] !== 'N') {
    return { valid: false, reason: 'Zeichen 26 muss „N" sein.' };
  }

  return {
    valid: false,
    reason: 'Format entspricht nicht dem bekannten Vaillant-Muster.',
  };
}
